import { COUNTRIES } from '@/lib/constants/demographics'
import { intlLocaleForUi } from '@/i18n'

const displayNamesCache = new Map<string, Intl.DisplayNames>()

function regionDisplayNames(locale: string): Intl.DisplayNames | null {
  const lang = intlLocaleForUi(locale)
  const cached = displayNamesCache.get(lang)
  if (cached) {
    return cached
  }
  try {
    const names = new Intl.DisplayNames([lang], { type: 'region' })
    displayNamesCache.set(lang, names)
    return names
  } catch {
    return null
  }
}

/**
 * UI-chrome country label for an ISO 3166-1 alpha-2 code.
 * Stored value stays the code; display follows the UI language.
 */
export function localizedCountryName(code: string, locale: string): string {
  const trimmed = code.trim()
  if (!trimmed) {
    return trimmed
  }
  const iso = trimmed.toUpperCase()
  const fromList =
    /^[A-Z]{2}$/.test(iso)
      ? COUNTRIES.find((c) => c.code === iso)
      : COUNTRIES.find((c) => c.name.toLowerCase() === trimmed.toLowerCase())
  const regionCode = fromList?.code ?? (/^[A-Z]{2}$/.test(iso) ? iso : null)
  if (regionCode) {
    const localized = regionDisplayNames(locale)?.of(regionCode)
    if (localized) {
      return localized
    }
    return fromList?.name ?? regionCode
  }
  return trimmed
}
